import an_pan from '../../../photos/an_pan.jpg';
import assortment_1 from '../../../photos/assortment_1.jpg';
import assortment_2 from '../../../photos/assortment_2.jpg';
import choco_chip_pan from '../../../photos/choco_chip_pan.jpg';
import cream_pan from '../../../photos/cream_pan.jpg';
import nuts_pan from '../../../photos/nuts_pan.jpg';
import roll_cinamon from '../../../photos/roll_cinamon.jpg';
import strawberry_pan from '../../../photos/strawberry_pan.jpg';
import nikunasu from '../../../photos/nikunasu.jpg';
import avocadoEbi from '../../../photos/avocadoEbi.jpg';
import pudding from '../../../photos/pudding.jpg';
import miniCheese from '../../../photos/miniCheese.jpg';
import chikuwa from '../../../photos/chikuwa.jpg';
import maple from '../../../photos/maple.jpg';
import tomates from '../../../photos/tomates.jpg';
import denish from '../../../photos/denish.jpg';

const photosData = [
    {
        img: denish,
        cols: 1,
    },
    {
        img: an_pan,
        cols: 1,
    },
    {
        img: assortment_1,
        cols: 1,
    },
    {
        img: choco_chip_pan,
        cols: 1,
    },
    {
        img: cream_pan,
        cols: 1,
    },
    {
        img: nuts_pan,
        cols: 1,
    },
    {
        img: assortment_2,
        cols: 1,
    },
    {
        img: roll_cinamon,
        cols: 1,
    },
    {
        img: strawberry_pan,
        cols: 1,
    },
    {
        img: nikunasu,
        cols: 1,
    },
    {
        img: avocadoEbi,
        cols: 1,
    },
    {
        img: pudding,
        cols: 1,
    }, 
    {
        img: miniCheese,
        cols: 1,
    },
    {
        img: maple,
        cols: 1,
    },
    {
        img: tomates,
        cols: 1,
    },
    {
        img: chikuwa,
        cols: 1,
    },
];

export default photosData;